<div class="col-sm-12" style="padding: 0!important;">
<mat-card>
    <mat-card-header>
        <mat-card-title>{{'Login / register with OTP'| translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>`
        <form [formGroup]="aFormGroup" *ngIf="isSendOTP">
            <mat-form-field class="col-sm-12">
                <input formControlName="email" id="emailorphone" matInput placeholder="{{'Enter email or phone number'| translate}}" [(ngModel)]="email" type="email" name="email" required>
            </mat-form-field>
            <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" formControlName="recaptcha"></ngx-recaptcha2>
        </form>
        <form [formGroup]="aFormGroup1" *ngIf="isValidateOTP">
            <mat-form-field class="col-sm-12">
                <input formControlName="otp" matInput placeholder="{{'Enter OTP'| translate}}"  type="number" [(ngModel)]="otp" name="otp" required>
            </mat-form-field>            
        </form>
    </mat-card-content>    
    <mat-card-actions style="text-align: center;">
        <button *ngIf="isSendOTP" [disabled]="!aFormGroup.valid" mat-raised-button (click)="login()" color="primary">{{'Send OTP'| translate}}</button>
        <button *ngIf="isValidateOTP" [disabled]="!aFormGroup1.valid" mat-raised-button (click)="validateOTP()" color="primary">{{'Validate OTP'| translate}}</button>
    </mat-card-actions>
</mat-card>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">{{'Please Wait.'| translate}} </p>
  </ngx-spinner>